import Typography from '@mui/joy/Typography';
import Stack from '@mui/joy/Stack';
import Tooltip from '@mui/joy/Tooltip';
import dayjs from 'dayjs';

import { InfoType } from 'stores/info_store';

import getIcon from 'utils/getIcon';

const InfoItemCalendar = ({info}: {info: InfoType}) => {
    const data = JSON.parse(info.data);
    const start = dayjs(data.start.dateTime).format('YYYY-MM-DD hh:mm a');
    const CalendarIcon = getIcon('CalendarMonthOutlined');
    return (
        <Tooltip
            arrow
            title="Calendar event"
        >
        <Stack
            alignItems="center"
            direction="row"
            spacing={1}>
            <CalendarIcon />
        <Stack>
            <Typography>{data.summary}</Typography>
            <Typography level="body-xs">{start}</Typography>
        </Stack>
        </Stack></Tooltip>
    );
};

const InfoItem = ({info}: {info: InfoType}) => {
    if(info.associated_type.startsWith('calendar')) {
        return <InfoItemCalendar info={info} />;
    }

    return (
        <div>
            <div>{info.data}</div>
        </div>
    );
};
export default InfoItem;
